import React, { useState, useEffect } from 'react';
import { func, number, bool } from 'prop-types';
import { useFormErrors } from '../../hooks/useFormErrors';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage, useForm } from '@laramie/ui';
import { APIS } from '../../../config/apis';
import { ServerRequest } from '../../../utils/apiweb';

import { CheckboxButton, CheckboxButtonGroup, Loading, InputLista, FormError, FormLabel, Modal, Select } from '../../common';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import { isEmptyString } from '../../../utils/validator';
import { GetTipoDatos } from '../../../utils/helpers';
import { useCatalogosVariable } from '../../hooks/useCatalogosVariable';
import {TIPS} from "../../../consts/tips";


const VariableModal = (props) => {

    //variables
    const entityInit = {
        id: 0,
        codigo: '',
        descripcion: '',
        idTipoTributo: 0,
        tipoDato: '',
        constante: false,
        predefinido: false,
        opcional: true,
        activo: true,
        global: false,
        lista: ''
    };

    //hooks
    const [state, setState] = useState({
        loading: false,
        showTipoTributo: true,
        entity: entityInit
    });
    
    const mount = () => {

        if (props.id > 0) {
            FindVariable();
        }
    
        const unmount = () => {}
        return unmount;
    }
    useEffect(mount, []);

    const catalogos = useCatalogosVariable();

    const [ formValues, formHandle, , formSet ] = useForm({
        codigo: '',
        descripcion: '',
        idTipoTributo: 0,
        tipoDato: '',
        constante: false,
        predefinido: false,
        opcional: true,
        activo: true,
        global: false,
        lista: ''
    });

    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const handleClickAceptar = () => {
        if (validate()) {
            if (props.id == 0) {
                AddVariable();
            }
            else {
                ModifyVariable();
            }
        };
    };
    const handleClickCancelar = () => {
        props.onDismiss();
    }
    
    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
            const message = error.message;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
            return {...prevState, loading: false};
            });
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }  
    
    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.codigo.length === 0) errors.codigo = VALIDATION_MESSAGE.REQUIRED;
        if (formValues.descripcion.length === 0) errors.descripcion = VALIDATION_MESSAGE.REQUIRED;
        if (formValues.tipoDato <= 0) errors.tipoDato = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.tipoDato == 'list' && formValues.lista.length <= 0) errors.lista = VALIDATION_MESSAGE.REQUIRED_OPTION;

        return errors;
    }   
    
    function FindVariable() {
    
        setState(prevState => {
          return {...prevState, loading: true};
        });
    
        const callbackSuccess = (response) => {
            response.json()
            .then((data) => {
                setState(prevState => {
                  return {...prevState, loading: false, showTipoTributo: !data.global, entity: data};
                });
                formSet({
                    codigo: data.codigo,
                    descripcion: data.descripcion,
                    idTipoTributo: data.idTipoTributo,
                    tipoDato: data.tipoDato,
                    constante: data.constante,
                    predefinido: data.predefinido,
                    opcional: data.opcional,
                    activo: data.activo,
                    global: data.global,
                    lista: data.lista         
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                  return {...prevState, loading: false};
                });
            });
        };
    
        const paramsUrl = `/${props.id}`;
    
        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.VARIABLE,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );
    
    }
    
    function AddVariable() {
        const method = REQUEST_METHOD.POST;
        const paramsUrl = null;
        SaveVariable(method, paramsUrl);
    }
    
    function ModifyVariable() {
        const method = REQUEST_METHOD.PUT;
        const paramsUrl = `/${props.id}`;
        SaveVariable(method, paramsUrl);
    }    

    function SaveVariable(method, paramsUrl) {

        setState(prevState => {
          return {...prevState, loading: true};
        });
    
        const callbackSuccess = (response) => {
          response.json()
          .then((row) => {
            setState(prevState => {
                return {...prevState, loading: false};
            });
            props.onConfirm(row.id);
          })
          .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
              return {...prevState, loading: false};
            });
          });
        };
    
        const dataBody = {
            ...state.entity.variable,
            codigo: formValues.codigo,
            descripcion: formValues.descripcion,
            idTipoTributo: !isEmptyString(formValues.idTipoTributo) && !formValues.global ? parseInt(formValues.idTipoTributo) : 0,
            tipoDato: formValues.tipoDato,
            constante: formValues.constante,
            predefinido: formValues.predefinido,
            opcional: formValues.opcional,
            activo: formValues.activo,
            global: formValues.global,
            lista: formValues.lista
        };
    
        ServerRequest(
            method,
            null,
            true,
            APIS.URLS.VARIABLE,
            paramsUrl,
            dataBody,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );
    
    }

    return (
        <>

        <Loading visible={state.loading}></Loading>

        <Modal
          size="lg"
          title={`Variable: ${(props && props.id > 0) ? state.entity.codigo : "Nuevo"}`}
          tipName={TIPS.NAME.MODALS.VARIABLE_MODAL}
          onEscape={() => props.onDismiss()}
          body={(<>
                <div className="row">

                    <div className="mb-3 col-12 col-lg-4">
                        <FormLabel htmlFor="codigo" required>Código</FormLabel>
                        <input
                            name="codigo"
                            type="text"
                            placeholder=""
                            className={`form-control ${errorOf('codigo') ? 'is-invalid' : ''}`}
                            value={ formValues.codigo }
                            onChange={ formHandle }
                            disabled={props.disabled} 
                            maxLength="50" 
                        />
                        <FormError message={errorOf('codigo')} />
                    </div>

                    <div className="mb-3 col-12 col-lg-8">
                        <FormLabel htmlFor="descripcion" required>Descripción</FormLabel>
                        <input
                            name="descripcion"
                            type="text"
                            placeholder=""
                            className={`form-control ${errorOf('descripcion') ? 'is-invalid' : ''}`}
                            value={ formValues.descripcion }
                            onChange={ formHandle }
                            disabled={props.disabled}  
                            maxLength="250"
                        />
                        <FormError message={errorOf('descripcion')} />
                    </div>

                    <div className="mb-3 col-12 col-lg-4">
                        <FormLabel htmlFor="tipoDato" required>Tipo de dato</FormLabel>
                        <Select
                            name="tipoDato"
                            className={`form-control ${errorOf('tipoDato') ? 'is-invalid' : ''}`}
                            value={ formValues.tipoDato }
                            onChange={({ target }) => {
                                formSet({...formValues,
                                        tipoDato: target.value,
                                        lista: (target.value == 'list') ? formValues.lista : ''
                                        });

                            }}
                            options={GetTipoDatos().map(item => ({value: item.key, label: item.value}))}
                            disabled={props.disabled}
                        />
                        <FormError message={errorOf('tipoDato')} />
                    </div>

                    <div className="mb-3 col-12 col-lg-4">
                        <label htmlFor="constante" className="form-label">Tipo de parámetro</label>
                        <Select
                            name="constante"
                            className="form-control"
                            value={ formValues.constante }
                            onChange={formHandle}
                            options={[{value: false, label: 'Variable'}, {value: true, label: 'Constante'}]}
                            disabled={props.disabled}
                        />
                        <FormError />
                    </div>

                    { state.showTipoTributo && (
                    <div className="mb-3 col-12 col-lg-4">
                        <label htmlFor="idTipoTributo" className="form-label">Tipo de tributo</label>
                        <InputLista
                            name="idTipoTributo"
                            placeholder=""
                            className="form-control"
                            value={ formValues.idTipoTributo }
                            onChange={ formHandle }
                            disabled={props.disabled}
                            lista="TipoTributo"
                            textItemZero="Todos los tributos"
                        />
                        <FormError />
                    </div>
                    )}

                </div>
                {formValues.tipoDato == 'list' && 
                <div className="row">
                    <div className="mb-3 col-12 col-lg-4">
                        <FormLabel htmlFor="lista" required>Lista</FormLabel>
                        <Select
                            name="lista"
                            className={`form-control ${errorOf('lista') ? 'is-invalid' : ''}`}
                            value={ formValues.lista }
                            onChange={({ target }) => {
                                formSet({...formValues, lista: target.value});
                            }}
                            options={catalogos.map(item => ({value: item.key, label: item.value}))}
                            disabled={props.disabled}
                        />
                        <FormError message={errorOf('lista')} />
                    </div>
                </div>
                }
                <div className="row">
                    
                    <div className="mb-3 col-12">
                        <CheckboxButtonGroup label="Opciones">
                            <CheckboxButton
                                name="predefinido"
                                label="Predefinido"
                                checked={formValues.predefinido}
                                onChange={({ target }) => {
                                formSet({...formValues, predefinido: target.checked, opcional: true});
                                }}
                                disabled={props.disabled}
                            />
                            <CheckboxButton
                                name="opcional"
                                label="Opcional"
                                checked={formValues.opcional}
                                onChange={formHandle}
                                disabled={props.disabled || !formValues.predefinido}
                            />
                            <CheckboxButton
                                name="activo"
                                label="Activo"
                                checked={formValues.activo}
                                onChange={formHandle}
                                disabled={props.disabled}
                            />
                            <CheckboxButton
                                name="global"
                                label="Global"
                                checked={formValues.global}
                                onChange={(e) => {
                                    setState(prevState => {
                                        return {...prevState, showTipoTributo: !e.target.checked};
                                    });
                                    formHandle(e)
                                }}
                                disabled={props.disabled}
                            />
                        </CheckboxButtonGroup>
                    </div>
                </div>
          </>)}
          footer={!props.disabled ? (<>
              <button className="btn btn-outline-primary" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Cancelar</button>
              <button className="btn btn-primary" data-dismiss="modal" onClick={ (event) => handleClickAceptar() }>Aceptar</button>
          </>) : (
              <button className="btn back-button" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Volver</button>
          )}
          footerClassName={props.disabled ? 'f-align' : ''}
        />

        </>
      );
    }
    

VariableModal.propTypes = {
    id: number.isRequired,
    disabled: bool,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired
};

VariableModal.defaultProps = {
    disabled: false
};    

export default VariableModal;
